'use strict';

module.exports = {
    QUOTES_RELEVANT_PDP: 'RELEVANT_PDP',
    QUOTES_ALL_PDP: 'PDP',
    FETCH_RELEVANT_QUOTE: 'FETCH_RELEVANT_QUOTE',
    FETCH_ALL_QUOTES: 'FETCH_ALL_QUOTES',
    BOOTSTRAP_SHIPPING_STORE: 'BOOTSTRAP_SHIPPING_STORE',
    OPEN_DETAILS_FROM_SIDEBAR: 'sidebar',
    OPEN_DETAILS_FROM_DESCRIPTION: 'description',
    TRACKING_COMPLETED: 'TRACKING_COMPLETED',
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/constants/shippingConstants.es.js